import { useMutation, useQueryClient } from '@tanstack/react-query'

import api from '@/lib/api'
import { useAccessToken, useCurrentUser } from '@/features/auth/state/auth'

export interface Darf {
  id: string
  anoCompetencia?: string
  mesCompetencia?: string
  value?: number
  status?: boolean
  id_user?: string
  observacao?: string
  id_apuracao_competencia?: string
  id_client?: string
  isPago?: boolean
  isAtivo?: boolean
  createdDate?: string
  deletedDate?: string | null
}

export interface CreateDarfRequest {
  anoCompetencia?: string
  mesCompetencia?: string
  value?: number
  status?: boolean
  id_user?: string
  observacao?: string
  id_apuracao_competencia: string
  id_client?: string
  isPago?: boolean
  isAtivo?: boolean
}

export interface CreateDarfResponse extends Darf {
  id: string
  id_apuracao_competencia: string
}


export function useCreateDarf() {
  const token = useAccessToken()
  const user = useCurrentUser()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (payload: CreateDarfRequest): Promise<CreateDarfResponse> => {
      if (!payload.id_apuracao_competencia?.trim()) {
        throw new Error('id_apuracao_competencia é obrigatório')
      }

      if (!user || !token) {
        throw new Error('Usuário não autenticado')
      }

      const response = await api.post<CreateDarfResponse>('/darfs', payload, {
        headers: { Authorization: `Bearer ${token}` }
      })

      if (!response.data?.id) {
        throw new Error('Erro ao criar DARF')
      }

      return response.data
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['darfs'] })
      queryClient.invalidateQueries({
        queryKey: ['darfs', 'apuracao', variables.id_apuracao_competencia]
      })
    }
  })
}

